// src/services/pushPrefsService.ts — Persistance users/{uid}.pushPrefs

import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { COLLECTIONS } from '../config/collections';
import type { UserPushPrefs } from '../types/pushPrefs';
import { sanitizeUserPushPrefs } from '../utils/pushPrefs';

export async function saveUserPushPrefs(
  uid: string,
  prefs: UserPushPrefs
): Promise<UserPushPrefs> {
  const sanitized = sanitizeUserPushPrefs(prefs) ?? {
    enabled: prefs.enabled !== false,
  };
  await updateDoc(doc(db, COLLECTIONS.users, uid), {
    pushPrefs: sanitized,
  });
  return sanitized;
}
